export default {
    
    clone_settings_modal_title: "Clone Settings",
    clone_settings_modal_message: "The configuration selected is going to overwrite all the configuration on the devices selected, do you want to continue?",
    clone_settings_modal_close: "Cancel",
    clone_settings_modal_save: "Save",
    
  };
  
  
  
  
  
  
  
  